import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import BzmIcon from '../../icons/BzmIcon';

export type SearchContext = 'transactions' | 'mockServices' | 'assets' | 'groups' | 'templates';

interface TagTextFilterProps {
  searchTerm?: string;
  defaultValue?: string;
  setSearchTerm: (searchTerm: string) => void;
  context: SearchContext;
  className?: string;
  placeholder?: string;
  inline?: boolean;
  minWith?: string;
}

const TagTextFilter = (props: TagTextFilterProps) => {
  const { t } = useTranslation('common');

  const handleFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
    props.setSearchTerm(event.target.value);
  };

  return (
    <div className={clsx(props.inline && 'form-inline', props.className)}>
      <div className="has-form-control-icon has-form-control-icon-left">
        <input
          type="text"
          className={clsx('form-control', 'qa-text-filter qa-text-filter-' + props.context)}
          style={{ minWidth: props.minWith ? props.minWith : '195px' }}
          placeholder={props.placeholder ? props.placeholder : t('tagTextFilter.searchByNameOrTagOrId')}
          onChange={handleFilterChange}
          value={props.searchTerm ? props.searchTerm : undefined}
          defaultValue={props.defaultValue ? props.defaultValue : undefined}
          autoComplete="off"
        />
        <span className="form-control-icon form-control-icon-left">
          <BzmIcon variant={'icon-bzm-search'} className={'icon-theme-gray-50'}></BzmIcon>
          <span className="sr-only">{t('actions.search')}</span>
        </span>
      </div>
    </div>
  );
};

export default TagTextFilter;
